"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M9.9087 10.4296c.1987.1988.4662.65.5874 1.026.1212-.376.3887-.8272.5875-1.026.3244-.3244.6107-.1724.8811.098.2703.2703.4223.5566.0979.8811-.1987.1987-.6499.4662-1.0259.5874.376.1212.8272.3887 1.0259.5874.3244.3244.1724.6108-.0979.8811-.2704.2704-.5567.4223-.8811.0979-.1988-.1987-.4663-.6499-.5875-1.0259-.1212.376-.3887.8273-.5874 1.026-.3245.3244-.6108.1724-.8811-.0979-.2704-.2704-.4224-.5567-.098-.8811.1988-.1988.65-.4663 1.026-.5875-.376-.1212-.8272-.3887-1.026-.5874-.3244-.3245-.1724-.6108.098-.8811.2703-.2704.5566-.4224.881-.098z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.496 11.9961c0-2.7614 2.2387-5 5.0001-5 2.7614 0 5 2.2386 5 5s-2.2386 5-5 5-5-2.2386-5-5zm5.0001-3c-1.6569 0-3 1.3431-3 3 0 1.6568 1.3431 3 3 3 1.6568 0 3-1.3432 3-3 0-1.6569-1.3432-3-3-3z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 4.5H2v15h2V21h2v-1.5h12V21h2v-1.5h2v-15zm-18 13v-11h16V9h-3.1606v2H20v2h-3.1606v2H20v2.5H4z"
  })];
};

exports.default = _default;